module.exports = "/fonts/vendor/quasar-extras/roboto-web-KFOlCnqEu92Fr1MmEU9fBBc-.woff?de8b7431b74642e830af4d4f4b513ec9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/roboto-font/web-font/KFOlCnqEu92Fr1MmEU9fBBc-.woff
// module id = aMcI
// module chunks = 49